/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CategoryDTO interface.
 */
export function instanceOfCategoryDTO(value) {
    return true;
}
export function CategoryDTOFromJSON(json) {
    return CategoryDTOFromJSONTyped(json, false);
}
export function CategoryDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
    };
}
export function CategoryDTOToJSON(json) {
    return CategoryDTOToJSONTyped(json, false);
}
export function CategoryDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
    };
}
